import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import ApprovalFinalAuthTab from '../../components/attendancemng/ApprovalFinalAuthTab';
import ApprovalFinalAuthModal from '../../components/attendancemng/ApprovalFinalAuthModal';
import * as approvalV2Api from '../../lib/api/approvalV2';

const ApprovalFinalAuthContainer = () => {
  const { enqueueSnackbar } = useSnackbar();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAuth, setSelectedAuth] = useState(null);
  const [canManage, setCanManage] = useState(null);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await approvalV2Api.getApprovalV2Auths({ docType: 'ORDER_BOOK' });
      setList(res.data.list || []);
    } catch (e) {
      enqueueSnackbar('전결 권한 조회 실패', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        const res = await approvalV2Api.getApprovalV2AuthManagePermission();
        const allowed = Boolean(res.data?.canManage);
        setCanManage(allowed);
        if (allowed) {
          fetchList();
        }
      } catch (e) {
        setCanManage(false);
      }
    };

    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = async (values) => {
    try {
      if (selectedAuth) {
        await approvalV2Api.editApprovalV2Auth(selectedAuth.authId, values);
        enqueueSnackbar('전결 권한을 수정했습니다.', { variant: 'success' });
      } else {
        await approvalV2Api.addApprovalV2Auth(values);
        enqueueSnackbar('전결 권한을 등록했습니다.', { variant: 'success' });
      }
      setModalOpen(false);
      setSelectedAuth(null);
      fetchList();
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '전결 권한 저장에 실패했습니다.', { variant: 'error' });
    }
  };

  const handleDelete = async (row) => {
    try {
      await approvalV2Api.removeApprovalV2Auth(row.authId);
      enqueueSnackbar('전결 권한을 삭제했습니다.', { variant: 'success' });
      fetchList();
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || '전결 권한 삭제에 실패했습니다.', { variant: 'error' });
    }
  };

  return (
    <>
      <BreadcrumbsContainer title="결재관리/전결 권한" />
      {canManage === false && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          전결 권한 관리 권한이 없습니다.
        </Alert>
      )}
      {canManage === true && (
        <ApprovalFinalAuthTab
          list={list}
          loading={loading}
          onAdd={() => {
            setSelectedAuth(null);
            setModalOpen(true);
          }}
          onEdit={(row) => {
            setSelectedAuth(row);
            setModalOpen(true);
          }}
          onDelete={handleDelete}
        />
      )}
      <ApprovalFinalAuthModal
        open={modalOpen}
        data={selectedAuth}
        onClose={() => {
          setModalOpen(false);
          setSelectedAuth(null);
        }}
        onSave={handleSave}
      />
    </>
  );
};

export default ApprovalFinalAuthContainer;
